import { render, staticRenderFns } from "./YoutubeEmbedPlayer.vue?vue&type=template&id=dd731c22&scoped=true&"
import script from "./YoutubeEmbedPlayer.vue?vue&type=script&lang=ts&"
export * from "./YoutubeEmbedPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubeEmbedPlayer.vue?vue&type=style&index=0&id=dd731c22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd731c22",
  null
  
)

export default component.exports